import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Grid } from '@mui/material'

import { TextFieldControl } from '../../../../components/form'
import { NewB2BFormState } from '../../qrs.types.ts'

export const UipField = (): React.ReactElement | null => {
  const { watch } = useFormContext<NewB2BFormState>()
  const reusableField = watch('reusable')

  return reusableField === 'false' ? (
    <Grid item xs={12}>
      <TextFieldControl<NewB2BFormState> name="uip" fullWidth label="Уникальный ID" />
    </Grid>
  ) : null
}
